"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PromotionCampaignBanner = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const CampaignBanner_1 = require("../CampaignBanner");
function PromotionCampaignBanner(props) {
    return ((0, jsx_runtime_1.jsx)(CampaignBanner_1.CampaignBanner, Object.assign({}, props, { featureFlagKey: "campaignsPromotionTopBanner" })));
}
exports.PromotionCampaignBanner = PromotionCampaignBanner;
